<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		mode?: 'both' | 'mx' | 'my' | 'none';
	}

	let { mode = 'mx', class: className, children, ...other }: Props = $props();
</script>

{#if mode === 'none'}
	{@render children?.()}
{:else}
	<div
		class={[
			className,
			{
				'm-4 xl:m-5 2xl:m-8': mode === 'both',
				'mx-4 xl:mx-5 2xl:mx-8': mode === 'mx',
				'my-4 xl:my-5 2xl:my-8': mode === 'my'
			}
		]}
		{...other}
	>
		{@render children?.()}
	</div>
{/if}
